<p-toolbar class="delivery-evidence-toolbar">
    <ng-template #start>
        <p-button icon="pi pi-arrow-left" [rounded]="true" [text]="true" (onClick)="goBack()" />
    </ng-template>
    <ng-template #center>
        <h3 class="p-toolbar-title">Delivery Evidence</h3>
        <p class="p-toolbar-subtitle">LOGISTICS PORTAL</p>
    </ng-template>    
</p-toolbar>

 <p-confirmdialog />
<div  class="delivery-evidence-container" *ngIf="deliveryStatusList.length > 0">
    <h2 class="delivery-text">Upload photos for shipment #{{shipment.proNumber}}</h2>
    <p class="delivery-instructions">Please provide clear photos of the items listed below to complete the delivery process.<br> To complete/update delivery please click on Submit Evidence</p>

    

    <div class="select-status-container">
         <p-select required [options]="deliveryStatusList" [(ngModel)]="selectedStatus" optionLabel="status" placeholder="Select a Status" (onChange)="statusChange($event)">
            <ng-template let-status #item>
                {{status.status}} - ({{status.description}})
            </ng-template>
         </p-select>
    </div>  
    
    <div class="update-address-card">
        <div class="update-address-container">
            <div class="address-input-container">
                <p-iconfield>
                    <p-inputicon class="pi pi-map-marker icon-map-marker" />
                    <p-autocomplete class="address-autocomplete" optionLabel="Address.Label" [(ngModel)]="selectedAddress" [suggestions]="addressList" (completeMethod)="search($event)" placeholder="Update Address" />
                </p-iconfield>
            </div>
        </div>
    </div>

    <div class="categories-list-container">
        @for (detail of categoryShipmentList; track detail.id) {
            <div class="categories-list-item">
                <p-card class="category-card">
                <ng-template #header>
                    <div class="category-header">
                        <div class="category-name">
                            <p class="category-name-text">{{detail.category.name}}</p>
                        </div>
                        <div class="justification">
                            <p-splitbutton severity="secondary" label="Justification" [model]="justifications" (onDropdownClick)="updateJustificationCommand(detail)" />
                        </div>
                    </div>
                </ng-template>

                <div class="card-content" *ngIf="!detail.categoryShipmentDetail[0]?.justification">
                    <input #fileInput (change)="onFileSelected($event, detail)"style="display:none;" type="file" accept=".png, .jpg, .jpeg" multiple>
                    <div class="upload-container" *ngIf="!detail.categoryShipmentDetail[0]?.photoEvidences?.length">
                        
                        <div class="upload-content" (click)="fileInput.click()">
                            <i class="pi pi-images upload-icon"></i>
                            <span class="upload-text">Upload Evidence</span>
                        </div>
                    </div>

                    <div class="carousel-container" *ngIf="detail.categoryShipmentDetail[0]?.photoEvidences?.length">
                        
                        <p-carousel  [value]="detail.categoryShipmentDetail[0].photoEvidences" [numVisible]="1" [numScroll]="1" [showNavigators]="false">
                            <ng-template let-photo #item>
                                    <div class="actions-pictures-button-container">
                                        <p-button (onClick)="fileInput.click()" icon="pi pi-plus" variant="outlined" severity="contrast"/>
                                        <p-button  severity="danger"  icon="pi pi-trash" iconPos="right" (onClick)="removePhoto(detail.categoryShipmentDetail[0], photo)"/>                                    
                                    </div>
                                    <div>
                                        <img [src]="photo.base64Photo" class="carousel-image">                                        
                                    </div>  
                                                                       
                            </ng-template>
                        </p-carousel>
                    </div>

                </div>

                <div class="justificatrion-selected" *ngIf="detail.categoryShipmentDetail[0]?.justification">
                    <p>Justification:</p>
                    <p-chip [label]="detail.categoryShipmentDetail[0].justification?.name" [removable]="true" (onRemove)="removeJustification(detail)"></p-chip>                                        
                </div>
                <ng-template #footer >
                    <p-button *ngIf="!detail.categoryShipmentDetail[0].justification" (onClick)="openCamera(detail)" class="take-photo-button" label="Take Photo" icon="pi pi-camera" iconPos="left"/>
                    <jabil-camera *ngIf="isCameraOpen && currentCategoryShipment?.id === detail.id" [maxPhotos]="(PICTURES_MAX_LENGTH - detail.categoryShipmentDetail[0].photoEvidences.length)"  (photoTaken)="savePhoto($event, detail.categoryShipmentDetail[0])" (closed)="closeCamera()" (initError)="handleInitError($event)"/>
                </ng-template>
            </p-card>
            </div>
        }

    </div>

    <div class="commments-container">
        <p-floatlabel variant="in">
            <textarea pTextarea id="comments" [(ngModel)]="comments" rows="3" cols="30"></textarea>
            <label for="comments">Comments</label>
        </p-floatlabel>
    </div>

    <div class="save-button-container">
        <p-button (onClick)="save()" class="save-button" label="Submit Evidence" icon="pi pi-send" iconPos="left"/>
    </div>

</div>